export default __webpack_public_path__ + "static/media/ef-core-logo.9601fa8c.png";